import './modal';

const $win = $(window);

$win.on('load', function(){
	const $logoClone = $('.js-logo a').clone()
		.insertBefore('.js-nav .nav__inner')
			.addClass('js-cloned nav__logo')
			.wrap('<div class="nav__logo-wrapper visible-xs-block visible-sm-block"></div>')

	const $navUtilsClone = $('.js-nav-utils').clone()
		.appendTo('.js-nav')
			.addClass('js-cloned visible-xs-block visible-sm-block nav__utils').removeClass('hidden-xs');

	$navUtilsClone.find('.js-modal').each(function() {
		$(this).magnificPopup({
			type: 'inline',
			preloader: false,
			modal: true
		});
	});

	const $link = $('.js-link').clone()
		.appendTo('.js-nav .nav__inner')
			.addClass('js-cloned visible-xs-block visible-sm-block nav__link').removeClass('hidden-xs');
});

$('.js-nav').on('click','.dropdown > a', function(event) {
	event.preventDefault();

	const $this = $(this);
	const $navDropdown = $this.next('.nav__dropdown');

	$this.parent().toggleClass('is-active');
	$navDropdown.stop().slideToggle(300);
})

$('.js-btn-burger, .js-nav-close').on('click', function(event) {
	event.preventDefault();

	$('.js-nav').toggleClass('is-visible');
	$('body').toggleClass('no-scroll');
})
